<template>
  <h2 class="heading-xs">Hur många är ni?</h2>
  <p class="my-12">Ett abonnemang eller familjeabonnemang.</p>
  <div class="flex gap-8 flex-row items-center flex-wrap">
    <AppButton
      :color="
        route?.path?.toLocaleLowerCase() === '/mobilabonnemang'
          ? 'primary'
          : 'secondary'
      "
      href="/mobilabonnemang"
      size="responsive"
      aria-label="Bara jag, köp abonnemang för en person"
      >Bara jag</AppButton
    >
    <AppButton
      :color="
        route?.path?.toLocaleLowerCase() === '/familjeabonnemang'
          ? 'primary'
          : 'secondary'
      "
      href="/familjeabonnemang"
      size="responsive"
      aria-label="Vi är fler, köp abonnemang för fler personer"
    >
      <span class="flex flex-col items-center">
        <span
          v-if="familyStore.FamilyPlanHasDiscount"
          :class="
            route?.path?.toLocaleLowerCase() === '/familjeabonnemang'
              ? 'text-inherit'
              : 'text-text-success'
          "
          class="heading-xxs"
        >
          Kampanj
        </span>
        Vi är fler
      </span>
    </AppButton>
  </div>
</template>

<script lang="ts" setup>
const route = useRoute();
const familyStore = useFamilyStore();

interface Props {
  configData?: any;
}
defineProps<Props>();
</script>

<style scoped></style>
